import {Component, Vue, Prop, Watch} from 'vue-facing-decorator';
import { ref } from "vue";


@Component({
    name : 'app-sidebar-menu-item',
    components: {
       
    }
})
export default class SideBarMenuItem extends Vue {
    @Prop({
        type: Object,
        default :() => ({})
    })
    item = '';

    @Prop({
        type: Number,
        default: 0
    })
    index!: number;

    @Prop({
        type: Boolean,
        default: true
    })
    root!: boolean;

    @Prop({
        type: String,
        default: null
    })
    parentItemKey = '';

    isActiveMenu = ref(false);
    itemKey : any = ref(null);

    @Watch('activeMenuItem')
    onActiveMenuItemChanged(newVal: any) {
        this.isActiveMenu = newVal === this.itemKey || newVal.startsWith(this.itemKey + '-');
        
    }

    get activeMenuItem(){
        return this.$store.getters["ui/activeMenuItem"];
    }

    itemClick(event : any, item : any){
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        if ((item.to || item.url) && this.$store.getters['ui/isSidebarActive'] ) {
            const sidebarEl = document.querySelector('.layout-sidebar');
            const topbarEl  = document.querySelector('.layout-menu-button');
            const c = (sidebarEl?.isSameNode(event.target) || sidebarEl?.contains(event.target) || topbarEl?.isSameNode(event.target) || topbarEl?.contains(event.target));
            if(c){
                this.$store.dispatch('ui/toggleMenuSidebar'); 
            }
        }
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }
        const foundItemKey = item.items ? (this.isActiveMenu ? this.parentItemKey : this.itemKey) : this.itemKey;
        this.$store.dispatch('ui/activeMenuItem', foundItemKey);
    }

    checkActiveRoute(item : any){
        return this.$route.path === item.to;
    }

    
    //onBeforeMount(){
    //    this.itemKey = this.parentItemKey ? this.parentItemKey + '-' + this.index : String(this.index);
    //    const activeItem =   this.$store.getters['ui/activeMenuItem'] ;
    //    this.isActiveMenu = activeItem === this.itemKey || activeItem ? activeItem.startsWith(this.itemKey + '-') : false;
    //}

    beforeMount(){
        this.itemKey = this.parentItemKey ? this.parentItemKey + '-' + this.index : String(this.index);
        const activeItem =   this.$store.getters['ui/activeMenuItem'] ;
        this.isActiveMenu = activeItem === this.itemKey || activeItem ? activeItem.startsWith(this.itemKey + '-') : false;
        
    }
   
}   